/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import OrderDetails from './modules/order-details/order-details';
import OrderDetailsView from './modules/order-details/order-details.view';

export * from './actions/get-sales-order-with-hydrations';
export * from './actions/get-tender-types';
export * from './common';
export * from './modules/order-confirmation';
export * from './modules/order-details';
export * from './modules/order-history';

export {
    OrderDetails,
    OrderDetailsView
};
